/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { getRequest, delRequest } from "../../../axiosRoutes/index";
import {
    Button,
    Box,
    CircularProgress,
    Typography,
    Grid,
    IconButton,
    DialogActions,
    DialogContentText,
    DialogContent,
    DialogTitle,
    Dialog,
    Snackbar,
    Alert,
    Card,
    CardContent,
    CardActions,
    useMediaQuery,
    Chip,
} from "@mui/material";
import dayjs from "dayjs";
import SideNavBar from "../sidebar/SideNav";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSnackbar } from "../../../axiosRoutes/snackbarConfig";
import CloseIcon from "@mui/icons-material/Close";
import AddEmployeeWorklog from "./AddEmployeeWorklog";
import { useInView } from "react-intersection-observer";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Calendar, dayjsLocalizer } from 'react-big-calendar'
import "react-big-calendar/lib/css/react-big-calendar.css";
import './employeeWorklogStyles.css'

const localizer = dayjsLocalizer(dayjs)

const EmployeeWorklogs = () => {
    const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
    const [hover, setHover] = useState(null);
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const [worklogs, setWorklogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [updateId, setUpdateId] = useState(null);
    const [updateBody, setUpdateBody] = useState(null);
    const [worklogId, setWorklogId] = useState(null);
    const [openWorklog, setOpenWorklog] = useState(false);
    const [worklogData, setWorklogData] = useState({
        date: "",
        projects: [],
        totalWorkHours: 0,
        hasBlocker: false,
        blockerDetails: "",
        onLeave: false,
    });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [isFetchingWorklogs, setIsFetchingWorklogs] = useState(false);
    const { ref, inView } = useInView({
        threshold: 0,
    });
    const [limit, setLimit] = useState(10);
    const [worklogTimePeriod, setWorklogTimePeriod] = useState({
            from: dayjs().startOf('month'),
            to: dayjs(),
        });
    const [monthAndYear, setMonthAndYear] = useState(dayjs().startOf('month'))
    const [myEvents, setMyEvents] = useState([])

    const EventComponent = ({ event }) => {
        return (
            <div style={{ display: "flex", flexDirection: "column"}}>
                <span>{event.name}</span>
                {event.projects.map((proj, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: 'space-between'}}>
                        <span>{proj.projectName} {proj?.workHours && `(${proj.workHours}h)`}</span>
                        {(event.hasBlocker && index === 0) && <span><Chip
                            icon={<WarningIcon style={{width: '25px', marginLeft: '0px', marginRight: '1px'}} />}
                            label=""
                            color="error"
                            size="small"
                            sx={{
                                "& .MuiChip-label": {
                                    display: "none",
                                },
                            }}
                        /></span>}
                    </div>
                ))}
            </div>
        );
    };

    useEffect(() => {
        if (inView) {
            if (limit < totalPages * 10) {
                setLimit((prev) => prev + 10);
            }
        }
    }, [inView]);

    const fetchWorklogs = async () => {
        const access = localStorage.getItem("access");
        const { from, to } = worklogTimePeriod;
        const fromDate = from.format('YYYY-MM-DD');
        const toDate = to.format('YYYY-MM-DD');
        try {
            setIsFetchingWorklogs(true);
            !isSmallScreen && setLoading(true);
            const response = await getRequest(`employee/worklog`, {
                headers: {
                    Authorization: `Bearer ${access}`,
                },
                params: {...(!isSmallScreen ? { limit: dayjs(fromDate).daysInMonth() } : { limit: limit }), from: fromDate, to: toDate},
            });
            setIsFetchingWorklogs(false);
            setTotalPages(response?.totals?.total_pages);
            const result = response?.data;
            const formattedWorklogs = result.map((worklog) => {
                if (worklog) {
                    const diffDays = dayjs().startOf('day').diff(dayjs(worklog.date).startOf('day'), 'day');
                    worklog.isLocked = diffDays > 2;
                    const date = new Date(worklog.date);
                    worklog.date = date.toLocaleDateString("en-GB");
                }
                return worklog;
            });
            setWorklogs(formattedWorklogs);
        } catch (error) {
            console.error("Error fetching Worklogs:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{
        setMyEvents(worklogs.map(log => ({
                id: log._id,
                title: log.name,
                start: dayjs(log.date, "DD/MM/YYYY").toDate(),
                end: dayjs(log.date, "DD/MM/YYYY").toDate(),
                projects: !log.onLeave ? log.projects : [{projectName: 'On Leave'}],
                hasBlocker: log.hasBlocker,
                totalWorkHours: log.totalWorkHours
            })))
    }, [worklogs])

    useEffect(() => {
        const { from, to } = worklogTimePeriod;
    
        if (from.isAfter(to)) {
            showSnackbar("Invalid date range: 'From' date cannot be after 'To' date.", "error");
            setWorklogTimePeriod({
                to: dayjs(),
                from: dayjs(),
            })
            return;
        }
    
        fetchWorklogs();
        }, [worklogTimePeriod])

    useEffect(() => {
        fetchWorklogs();
    }, [page, limit]);

    const handleDelete = async () => {
        try {
            const access = localStorage.getItem("access");
            const response = await delRequest(`employee/worklog/${deleteId}`, access);
            fetchWorklogs();
            handleClose();
            showSnackbar(response.message, "success");
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || error.message || "An error occurred";
            showSnackbar(errorMessage, "error");
        }
    };

    const handleClickOpen = (id) => {
        setDeleteId(id);
        setOpen(true);
    };

    const handleOpen = () => {
        setOpenModal(true);
    };

    const selectWorklog = (id, worklog) => {
        setUpdateBody(worklog)
        setUpdateId(id);
        handleOpen();
    };

    const handleWorklog = (id) => {
        setOpenWorklog(true);
        setWorklogId(id);
    };

    useEffect(() => {
        const fetchWorklog = async () => {
            if (worklogId !== null) {
                const access = localStorage.getItem("access");
                try {
                    setLoading(true);
                    const response = await getRequest(`employee/worklog/${worklogId}`, {
                        headers: {
                            Authorization: `Bearer ${access}`,
                        },
                    });
                    const formatDate = new Date(response.date)
                        .toISOString()
                        .split("T")[0];
                    setWorklogData({
                        date: formatDate,
                        projects: response.projects,
                        totalWorkHours: response.totalWorkHours,
                        hasBlocker: response.hasBlocker,
                        blockerDetails: response.blockerDetails || "N/A",
                        onLeave: response.onLeave || false,
                    });
                } catch (error) {
                    console.error("Error fetching Worklog:", error);
                } finally {
                    setLoading(false);
                }
            } else {
                setWorklogData({
                    date: "",
                    projects: [],
                    totalWorkHours: 0,
                    hasBlocker: false,
                    blockerDetails: "",
                    onLeave: false,
                });
            }
        };
        fetchWorklog();
    }, [worklogId]);

    useEffect(()=>{
        setWorklogTimePeriod({
            from: dayjs(monthAndYear).startOf('month'),
            to: dayjs(monthAndYear).endOf('month')
        })
    }, [monthAndYear])

    const handleClose = () => {
        setOpenModal(false);
        setOpen(false);
        setOpenWorklog(false);
        setWorklogId(null);
        setDeleteId(null);
        setUpdateId(null);
        fetchWorklogs();
    };

    if (loading) {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100vh"
                textAlign="center"
            >
                <CircularProgress size={50} sx={{ color: "#FF5722" }} />
                <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
                    Loading...
                </Typography>
            </Box>
        );
    }

    return (
        <>
            <div className="app-container" style={{ color: "#fff", display: "flex" }}>
                <SideNavBar />
                <div
                    style={{
                        flex: 1,
                        margin: `${isSmallScreen ? "3rem" : "0.5rem"} 0.5rem 0.5rem 0.5rem`,
                    }}
                >
                    <Box sx={{ backgroundColor: "#000", marginTop: { xs: 1, md: 0 } }}>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                                justifyContent: { xs: "center", md: "space-between" },
                                flexDirection: { xs: "column", md: "row" },
                                padding: "1rem",
                            }}
                        >
                            <Grid item>
                                <h1>My Worklogs</h1>
                            </Grid>
                            <Grid item sx={{...( !isSmallScreen && { display: "flex", gap: "1rem" } ),}}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        views={['year', 'month']}
                                        label="Select Year & Month"
                                        value={monthAndYear}
                                        onMonthChange={(newValue) => setMonthAndYear(newValue)}
                                        sx={{
                                                "& .MuiInputBase-root": {
                                                    color: "#fff",
                                                    borderColor: "#FF5722",
                                                    "& fieldset": {
                                                        borderColor: "#FF5722",
                                                    },
                                                    "&:hover fieldset": {
                                                        borderColor: "#FF5722",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "#FF5722",
                                                    },
                                                },
                                                "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                                                    color: "#fff",
                                                },
                                                "& .MuiFormLabel-root": {
                                                    color: "#fff",
                                                },
                                            }}
                                    />
                                </LocalizationProvider>
                                <Grid sx={{
                                    ...(isSmallScreen
                                        ? { marginTop: '24px', display: 'flex', justifyContent: 'center' }
                                        : {
                                            display: 'flex',
                                            paddingTop: '15px',
                                        }),
                                }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleOpen}
                                        sx={{
                                            backgroundColor: "#fff",
                                            color: "black",
                                            "&:hover": {
                                                backgroundColor: "#e1e1e1",
                                            },
                                            height: "40px",
                                            ...(isSmallScreen && { width: "100%" }),
                                        }}
                                    >
                                        Add Worklog
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        {worklogs.length === 0 ? (
                            <Typography variant="h6" sx={{ color: "#fff", textAlign: "center" }}>
                                No Data Yet
                            </Typography>
                        ) : (
                            <>
                                {!isSmallScreen ? (
                                    <div><Calendar
                                        views={["month"]}
                                        selectable
                                        localizer={localizer}
                                        date={worklogTimePeriod.from}
                                        defaultView="month"
                                        events={myEvents}
                                        style={{ height: "80vh", minWidth: '1200px' }}
                                        components={{ event: EventComponent }}
                                        eventPropGetter={(event) => ({
                                            style: {
                                                backgroundColor: (event.totalWorkHours >= 10 || event.totalWorkHours <= 4) ? "#dc3545" : event.totalWorkHours < 8 ? "#ffc107" : "#28a745",
                                                color: "white",
                                                borderRadius: "5px",
                                                border: "none",
                                                padding: "10px 5px",
                                            },
                                        })}
                                        toolbar={false}
                                        onSelectEvent={(event)=>{handleWorklog(event.id)}}
                                    /></div>
                                ) : (
                                    <Grid container spacing={1} justifyContent="center">
                                        {worklogs.map((worklog, id) => (
                                            <Grid item xs={12} key={id}>
                                                <Card
                                                    ref={id + 1 === worklogs.length ? ref : null}
                                                    sx={{
                                                        backgroundColor: "#101010",
                                                        color: "#fff",
                                                    }}
                                                    onMouseEnter={() => setHover(id)}
                                                    onMouseLeave={() => setHover(null)}
                                                    onClick={() => handleWorklog(worklog._id)}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        <CardContent>
                                                            <Typography variant="h6">Worklog - {worklog.date}</Typography>
                                                            <Typography variant="body2">
                                                                Date: {worklog.date}
                                                                <br />
                                                                Hours: {worklog.totalWorkHours}h
                                                                <br />
                                                                Projects: {worklog.projects.length}
                                                                <br />
                                                                Status:{" "}
                                                                {worklog.onLeave ? (
                                                                    <Chip
                                                                        label="Leave"
                                                                        color="info"
                                                                        size="small"
                                                                    />
                                                                ) : worklog.totalWorkHours <= 4 ? (
                                                                    <Chip
                                                                        label="Low Hours"
                                                                        color="warning"
                                                                        size="small"
                                                                    />
                                                                ) : worklog.totalWorkHours >= 10 ? (
                                                                    <Chip
                                                                        label="High Hours"
                                                                        color="error"
                                                                        size="small"
                                                                    />
                                                                ) : (
                                                                    <Chip
                                                                        label="Normal"
                                                                        color="success"
                                                                        size="small"
                                                                    />
                                                                )}
                                                                <br />
                                                                Blocker:{" "}
                                                                {worklog.hasBlocker ? (
                                                                    <Chip
                                                                        icon={<WarningIcon />}
                                                                        label="Yes"
                                                                        color="error"
                                                                        size="small"
                                                                    />
                                                                ) : (
                                                                    <Chip
                                                                        icon={<CheckCircleIcon />}
                                                                        label="No"
                                                                        color="success"
                                                                        size="small"
                                                                    />
                                                                )}
                                                            </Typography>
                                                        </CardContent>
                                                        <CardActions>
                                                            <IconButton
                                                                style={{
                                                                    color: "#fff",
                                                                    backgroundColor: "#1976D2",
                                                                    marginRight: "1px",
                                                                }}
                                                                aria-label="view"
                                                                size="medium"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleWorklog(worklog._id);
                                                                }}
                                                            >
                                                                <VisibilityIcon fontSize="inherit" />
                                                            </IconButton>
                                                            <IconButton
                                                                sx={{
                                                                    color: "#fff",
                                                                    backgroundColor: "#4CAF50",
                                                                    marginRight: "1px",
                                                                    "&.Mui-disabled": {
                                                                        backgroundColor: "rgb(134, 200, 134)",
                                                                        color: "rgb(255, 255, 255)",
                                                                    },
                                                                }}
                                                                aria-label="edit"
                                                                size="medium"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    selectWorklog(worklog._id);
                                                                }}
                                                                disabled={worklog.isLocked}
                                                            >
                                                                <EditIcon fontSize="inherit" />
                                                            </IconButton>
                                                            <IconButton
                                                                sx={{
                                                                    color: "#fff",
                                                                    backgroundColor: "#F44336",
                                                                    marginRight: "1px",
                                                                    "&.Mui-disabled": {
                                                                        backgroundColor: "rgb(255, 133, 117)",
                                                                        color: "rgb(255, 255, 255)",
                                                                    },
                                                                }}
                                                                disabled={worklog.isLocked}
                                                                aria-label="delete"
                                                                size="medium"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleClickOpen(worklog._id);
                                                                }}
                                                            >
                                                                <DeleteIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </CardActions>
                                                    </Box>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                )}
                            </>
                        )}
                    </Box>
                    {/* Worklog Details Modal */}
                    <Dialog
                        open={openWorklog}
                        maxWidth
                        sx={{
                            "& .MuiPaper-root": {
                                backgroundColor: "#212121",
                                opacity: 0.9,
                                color: "#fff",
                                padding: "5px",
                                maxWidth: { xs: "90%", md: "60%" },
                                border: "2px solid #D0521B",
                            },
                        }}
                    >
                        <DialogTitle
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "22px",
                                fontWeight: "bold",
                            }}
                        >
                            Worklog Details - {worklogData.date}
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    color: "#fff",
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Grid
                                container
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    borderTop: "2px solid #D0521B",
                                    paddingTop: "1rem",
                                }}
                            >
                                <Grid item xs={12} md={6}>
                                    <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                        <b>Date:</b> {worklogData.date}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                        <b>Total Work Hours:</b> {worklogData.totalWorkHours}h
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                        <b>Status:</b>{" "}
                                        {worklogData.onLeave ? (
                                            <Chip
                                                label="Leave"
                                                color="info"
                                                size="small"
                                            />
                                        ) : worklogData.totalWorkHours <= 4 ? (
                                            <Chip
                                                label="Low Hours"
                                                color="warning"
                                                size="small"
                                            />
                                        ) : worklogData.totalWorkHours >= 10 ? (
                                            <Chip
                                                label="High Hours"
                                                color="error"
                                                size="small"
                                            />
                                        ) : (
                                            <Chip
                                                label="Normal"
                                                color="success"
                                                size="small"
                                            />
                                        )}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                        <b>Has Blocker:</b>{" "}
                                        {worklogData.hasBlocker ? (
                                            <Chip
                                                icon={<WarningIcon />}
                                                label="Yes"
                                                color="error"
                                                size="small"
                                            />
                                        ) : (
                                            <Chip
                                                icon={<CheckCircleIcon />}
                                                label="No"
                                                color="success"
                                                size="small"
                                            />
                                        )}
                                    </Typography>
                                </Grid>
                                {worklogData.hasBlocker && (
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                            <b>Blocker Details:</b> {worklogData.blockerDetails}
                                        </Typography>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <Typography
                                        variant="h6"
                                        sx={{ marginTop: 2, marginBottom: 1, fontWeight: "bold" }}
                                    >
                                        Projects:
                                    </Typography>
                                    {worklogData.onLeave ? (
                                        <Typography variant="body1" sx={{ fontStyle: 'italic', color: '#888' }}>
                                            You were on leave - No project work recorded
                                        </Typography>
                                    ) : worklogData.projects.length === 0 ? (
                                        <Typography variant="body1" sx={{ fontStyle: 'italic', color: '#888' }}>
                                            No projects recorded
                                        </Typography>
                                    ) : (
                                        worklogData.projects.map((project, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    backgroundColor: "#333",
                                                    padding: "1rem",
                                                    marginBottom: "1rem",
                                                    borderRadius: "8px",
                                                }}
                                            >
                                                <Typography variant="body1">
                                                    <b>Project Name:</b> {project.projectName}
                                                </Typography>
                                                <Typography variant="body1">
                                                    <b>Work Hours:</b> {project.workHours}h
                                                </Typography>
                                                <Typography variant="body1">
                                                    <b>Update:</b> {project.update}
                                                </Typography>
                                            </Box>
                                        ))
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                    {/* Delete Confirmation Dialog */}
                    <Dialog
                        open={open}
                        sx={{
                            "& .MuiPaper-root": {
                                backgroundColor: "#212121",
                                color: "#fff",
                                padding: "15px",
                            },
                            "& .MuiDialogTitle-root": {
                                padding: "5px",
                            },
                            "& .MuiDialogContentText-root": {
                                color: "#fff",
                            },
                            "& .MuiDialogContent-root": {
                                padding: "5px",
                            },
                            "& .MuiDialogActions-root": {
                                padding: "5px",
                            },
                        }}
                    >
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are You Sure You Want to Delete this Worklog?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={handleClose}
                                sx={{
                                    backgroundColor: "#A6A6A6",
                                    color: "#fff",
                                    "&:hover": { backgroundColor: "#B8B8B8" },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDelete}
                                sx={{
                                    backgroundColor: "#E5622D",
                                    color: "#fff",
                                    "&:hover": { backgroundColor: "#D0521B" },
                                }}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <AddEmployeeWorklog
                        open={openModal}
                        worklogId={updateId}
                        worklogBody={updateBody}
                        handleClose={handleClose}
                        isLocked={worklogs.find(w => w._id === updateId)?.isLocked}
                    />
                </div>
            </div>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {isSmallScreen && (
                <Grid
                    container
                    width="100%"
                    height="10vh"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                        position: "fixed",
                        bottom: isFetchingWorklogs ? "20px" : "-100px",
                        transition: "bottom 0.5s ease",
                    }}
                >
                    <CircularProgress size="3rem" sx={{ color: "#FF5722" }} />
                </Grid>
            )}
        </>
    );
};

export default EmployeeWorklogs;